import React from 'react';
import LogoS from '../../assets/images/hero section.jpg';
import './imagesection.scss'

const Imagesection = () => {
  return (
    <div><img src={LogoS} alt="JavaScript,  Developer" className='image-section'/></div>
  )
}

export default Imagesection